<script setup lang="ts">
import type HtmlTag from '~/types/htmlTag'

type Props = {
  amount: string | number
  strikethrough?: boolean
  tag?: Extract<HtmlTag, 'div' | 'span'>
  dataTestId?: string
}

withDefaults(defineProps<Props>(), {
  strikethrough: false,
  tag: 'div',
  dataTestId: undefined,
})
</script>

<template>
  <div class="tw-relative">
    <component :is="tag" class="tw-flex tw-items-center">
      <span
        class="tw-mr-1"
        :data-test-id="dataTestId"
        :class="{ 'tw-font-medium': strikethrough }"
        >{{ parseInt(amount as string) }}</span
      >
      <i class="icon-grooviz" :class="{ 'tw-font-medium': strikethrough }" />
    </component>
    <div
      v-if="strikethrough"
      class="tw-absolute -tw-left-px tw-top-1/2 tw-h-px tw-w-[calc(100%+2px)] -tw-translate-y-1/2 tw-bg-gray-500"
      data-test-id="groovizStrikethrough"
    />
  </div>
</template>
